import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Star, MapPin } from "lucide-react";
import { TierChip } from "@/components/TierBadge";

const MONTHS_PT = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];

export default function SpotlightSection() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/public/spotlight").then(({ data }) => setData(data)).finally(() => setLoading(false));
  }, []);
  if (loading || !data?.referrer) return null;
  const [y, m] = (data.month || "").split("-");
  const monthLabel = m ? MONTHS_PT[parseInt(m, 10) - 1] : "";
  return (
    <section className="max-w-5xl mx-auto px-6 py-16" data-testid="public-spotlight">
      <div className="rounded-3xl bg-gradient-to-br from-[#E7B24A] via-[#D69E2E] to-[#B7871C] p-8 md:p-10 text-white overflow-hidden relative">
        <div className="absolute -top-8 -right-8 w-48 h-48 rounded-full bg-white/10 blur-2xl"/>
        <div className="relative flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
          <div className="w-20 h-20 rounded-3xl bg-white/25 grid place-items-center backdrop-blur-sm flex-shrink-0">
            <Star className="w-10 h-10 text-white" fill="currentColor"/>
          </div>
          <div className="flex-1">
            <div className="eyebrow !text-white/80">Referenciador do mês · {monthLabel} {y}</div>
            <h2 className="font-heading text-4xl md:text-5xl mt-2">{data.referrer.display_name}</h2>
            <div className="mt-2 flex items-center gap-3 flex-wrap text-sm text-white/85">
              {data.referrer.locality && <span className="flex items-center gap-1"><MapPin className="w-4 h-4"/> {data.referrer.locality}</span>}
              {data.referrer.tier && <TierChip tier={data.referrer.tier}/>}
            </div>
          </div>
          <div className="text-center md:text-right">
            <div className="text-5xl md:text-6xl font-heading">{data.referrer.hires_this_month}</div>
            <div className="text-sm text-white/85">contratações este mês</div>
          </div>
        </div>
      </div>
    </section>
  );
}
